import axios from "axios";
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();

/**
 * Get filters for some need's attributes.
 * 
 * @returns {Promise<Object>}
 */
export function list () {
  return axios.get(`${apiUrl}/need/filters`);
}
